const e = "Farbfeld, aktuelle Farbe ist {color}", r = "Feld für Farbe", o = "Farbpalette", l = "Voreingestellte Farben", t = "Benutzerdefinierte voreingestellte Farben", n = "Farbe hinzufügen", c = "Farbe löschen", s = "Benutzerdefinierte Farbe, HEX-Format", a = "Farbe zur Liste benutzerdefinierter Farben hinzufügen", i = "Feld für benutzerdefinierte Farbe leeren", F = "Farbe mit Rücktaste löschen", d = {
  currentColor: e,
  emptyColor: r,
  palette: o,
  presetColors: l,
  customColors: t,
  addColor: n,
  clearColor: c,
  colorField: s,
  colorFieldConfirm: a,
  colorFieldClear: i,
  deleteColorDescriber: F
};
export {
  n as addColor,
  c as clearColor,
  s as colorField,
  i as colorFieldClear,
  a as colorFieldConfirm,
  e as currentColor,
  t as customColors,
  d as default,
  F as deleteColorDescriber,
  r as emptyColor,
  o as palette,
  l as presetColors
};
